import React, { useState, useContext } from 'react';
import classNames from 'classnames';
import { UserContext } from './UserContext.jsx';
import AppTopBar from './AppTopbar.jsx';
import { LocationSensorMap } from './pages/LocationSensorMap.jsx';
import { Route, Routes } from 'react-router-dom';
import { ActiveViewersPanel } from './components/ActiveViewersPanel.jsx';
import { usePresenceHeartbeat } from './hooks/usePresenceHeartbeat.js';

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './fonts.css';
import './App.scss';

const App = () => {
	const [globalFilterValue, setGlobalFilterValue] = useState('');
	const user = useContext(UserContext);
	usePresenceHeartbeat();

	const signedIn = Boolean(user?.userInfo);
	const containerClassName = classNames('layout-wrapper', 'menu-layout-static', 'layout-menu-static-inactive');

	return (
		<div className={containerClassName}>
			<AppTopBar activeUser={user} />
			{signedIn ? (
				<div className="layout-main is-map">
					<Routes>
						<Route path="/" element={<LocationSensorMap globalFilterValue={globalFilterValue} setGlobalFilterValue={setGlobalFilterValue} />} />
					</Routes>
					<ActiveViewersPanel />
				</div>
			) : (
				<div className="layout-main" style={{ textAlign: 'center', padding: '20px' }}>
					<h1 style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--pit-ink)', marginTop: '100px' }}>
						Unable to load profile
					</h1>
					<p style={{ fontSize: '20px', color: 'var(--pit-muted)' }}>
						Sign in with your flypittsburgh account, then refresh if this persists.
					</p>
				</div>
			)}
		</div>
	);
}

export default App;
